import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import cepFieldComponent from "@/components/child/form/cepfield.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import AreaAbrangenciaFaixaModel from "@/models/areaAbrangencia/areaAbrangenciaFaixaModel";
import AreaAbrangenciaModel from "@/models/areaAbrangencia/areaAbrangenciaModel";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import Ufs from "@/models/enum/ufs";
import areaAbrangenciaService from "@/services/areaAbrangenciaService";
import CidadeService from "@/services/external/cidadeService";
import EditComponentBase from "../editComponentBase";

import "../crud.scss";

@Component({
    components: {
        dataTooltipComponent,
        gridComponent,
        decimalComponent,
        fieldsetComponent,
        buttonIncluirComponent,
        actionBarComponent,
        cepFieldComponent,
        comboComponent,
    },
})
export default class AreaAbrangenciaEditComponent extends EditComponentBase<AreaAbrangenciaModel> {
    private cidadeService = new CidadeService();

    private estadosOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(Ufs);
    private cidadesOptions: Array<Object> = [];

    private faixa = new AreaAbrangenciaFaixaModel();

    private gridFaixaColums: Array<GridColumn> = [
        new GridColumn("nomeEstado", "Estado", GridColumnType.String),
        new GridColumn("nomeCidade", "Cidade", GridColumnType.String),
    ];

    // Para recarregar o grid de faixas
    private gridReloads = 0;

    private async beforeMount() {
        await this.setPropsCached(areaAbrangenciaService, "areaAbrangencia", new AreaAbrangenciaModel());
    }

    public async onLoadModel() {
        for (const faixa of this.model.areaAbrangenciaFaixas) {
            faixa.nomeEstado = EnumExtensions.getNameByValue(Ufs, faixa.estadoId);
            faixa.nomeCidade = (await this.cidadeService.getCidade(faixa.cidadeId))!.nome;
        }

        this.gridReloads++;
    }

    private async onLoadCidades(estadoId: number) {
        try {
            this.cidadesOptions = [];
            if (estadoId) {
                const cidades = this.model.areaAbrangenciaFaixas.map(f => f.cidadeId);
                this.cidadesOptions = await this.cidadeService.get(estadoId, cidades).withLoading();
            }
        } catch {}
    }

    private async onAddFaixa() {
        const model = new AreaAbrangenciaFaixaModel();
        model.updateFrom(this.faixa);

        model.nomeEstado = EnumExtensions.getNameByValue(Ufs, this.faixa.estadoId);
        model.nomeCidade = (await this.cidadeService.getCidade(this.faixa.cidadeId))!.nome;

        this.faixa = new AreaAbrangenciaFaixaModel();
        this.model.areaAbrangenciaFaixas.push(model);
    }

    private onRemoveFaixa(faixa: AreaAbrangenciaFaixaModel) {
        const index = this.model.areaAbrangenciaFaixas.indexOf(faixa);
        this.model.areaAbrangenciaFaixas.splice(index, 1);
    }
}

